import React from "react";
import { storiesOf } from "@storybook/react";
import { text, number, withKnobs } from "@storybook/addon-knobs";
import withReadme from "storybook-readme/with-readme";
import { Language } from "@emcm-ui/component-theme";
import StaticRenderer from "@emcm-ui/component-static-renderer";
import SiteFooter from "./index";
import "./SiteFooter.css";
import SiteFooterREADME from "../README.md";

const stories = storiesOf("Components/SiteFooter", module);

stories.addDecorator(withKnobs);
stories.addDecorator(withReadme(SiteFooterREADME));

const lists = [
  <SiteFooter.NavList title="About Thomson Reuters">
    <SiteFooter.NavItem title="About us" href="#" />
    <SiteFooter.NavItem title="Investor relations" href="#" />
    <SiteFooter.NavItem title="Newsroom" href="#" />
    <SiteFooter.NavItem title="Press release" href="#" />
    <SiteFooter.NavItem title="Innovation" href="#" />
    <SiteFooter.NavItem title="Global site directory" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="Products & Services">
    <SiteFooter.NavItem title="All products" href="#" />
    <SiteFooter.NavItem title="Financial" href="#" />
    <SiteFooter.NavItem title="Government" href="#" />
    <SiteFooter.NavItem title="Legal" href="#" />
    <SiteFooter.NavItem title="Reuters news agency" href="#" />
    <SiteFooter.NavItem title="Risk management" href="#" />
    <SiteFooter.NavItem title="Tax & accounting" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="Resources">
    <SiteFooter.NavItem title="Careers" href="#" />
    <SiteFooter.NavItem title="Answers On" href="#" />
    <SiteFooter.NavItem title="Product logins" href="#" />
    <SiteFooter.NavItem title="Mobile apps" href="#" />
    <SiteFooter.NavItem title="Know 360 publication" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="Contact Us">
    <SiteFooter.NavItem title="Support & Training" href="#" />
    <SiteFooter.NavItem title="Office locations" href="#" />
    <SiteFooter.NavItem title="Media relations" href="#" />
    <SiteFooter.NavItem title="sales" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="Connect">
    <SiteFooter.NavItem title="Support & Training" href="#" />
    <SiteFooter.NavItem title="Office locations" href="#" />
    <SiteFooter.NavItem title="Media relations" href="#" />
    <SiteFooter.NavItem title="sales" href="#" />
  </SiteFooter.NavList>
];

const arabicLists = [
  <SiteFooter.NavList title="حول تومسون رويترز">
    <SiteFooter.NavItem title="أبوت أوس" href="#" />
    <SiteFooter.NavItem title="علاقات المستثمرين" href="#" />
    <SiteFooter.NavItem title="نيوسروم" href="#" />
    <SiteFooter.NavItem title="بيان صحفي" href="#" />
    <SiteFooter.NavItem title="الابتكار" href="#" />
    <SiteFooter.NavItem title="غلوبال سيت ديركتوري" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="المنتجات والخدمات">
    <SiteFooter.NavItem title="جميع المنتجات" href="#" />
    <SiteFooter.NavItem title="فينانسيال" href="#" />
    <SiteFooter.NavItem title="غوفرنمنت" href="#" />
    <SiteFooter.NavItem title="ليجال" href="#" />
    <SiteFooter.NavItem title="وكالة رويترز للأنباء " href="#" />
    <SiteFooter.NavItem title="إدارة المخاطر" href="#" />
    <SiteFooter.NavItem title="تاكس & أكونتينغ" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="الموارد">
    <SiteFooter.NavItem title="وظائف" href="#" />
    <SiteFooter.NavItem title="أنسويرس أون" href="#" />
    <SiteFooter.NavItem title="برودوكت لوجينز" href="#" />
    <SiteFooter.NavItem title="موبيل أبس" href="#" />
    <SiteFooter.NavItem title="نو 360 بوبليكاتيونس" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="اتصل بنا">
    <SiteFooter.NavItem title="الدعم والتدريب" href="#" />
    <SiteFooter.NavItem title="مواقع المكاتب" href="#" />
    <SiteFooter.NavItem title="العلاقات الإعلامية" href="#" />
    <SiteFooter.NavItem title="ساليس" href="#" />
  </SiteFooter.NavList>,
  <SiteFooter.NavList title="كونيكت">
    <SiteFooter.NavItem title="فاسيبوك" href="#" />
    <SiteFooter.NavItem title="تويتر" href="#" />
    <SiteFooter.NavItem title="لينكيدين" href="#" />
    <SiteFooter.NavItem title="Google+" href="#" />
    <SiteFooter.NavItem title="يوتوب" href="#" />
    <SiteFooter.NavItem title="إنستاغرام" href="#" />
  </SiteFooter.NavList>
];

stories
  .add("Default", () => (
    <SiteFooter
      searchFormAction={text("searchFormAction", "/")}
      searchFormMethod={text("searchFormMethod", "get")}
      searchInputName={text("searchInputName", "q")}
      typeaheadUrl={text(
        "typeaheadUrl",
        "//content.atomz.com/autocomplete/sp10/05/0d/51?_=1506335725065"
      )}
    >
      {lists.slice(0, number("Number of lists", lists.length))}
    </SiteFooter>
  ))
  .add("Language: Arabic (RTL)", () => (
    <Language code="ar">
      <SiteFooter
        searchFormAction={text("searchFormAction", "/")}
        searchFormMethod={text("searchFormMethod", "get")}
        searchInputName={text("searchInputName", "q")}
        typeaheadUrl={text(
          "typeaheadUrl",
          "//content.atomz.com/autocomplete/sp10/05/0d/51?_=1506335725065"
        )}
      >
        {arabicLists.slice(0, number("Number of lists", lists.length))}
      </SiteFooter>
    </Language>
  ))
  .add("Rehydrated", () => (
    <StaticRenderer>
      <SiteFooter
        searchFormAction={text("searchFormAction", "/")}
        searchFormMethod={text("searchFormMethod", "get")}
        searchInputName={text("searchInputName", "q")}
        typeaheadUrl={text(
          "typeaheadUrl",
          "//content.atomz.com/autocomplete/sp10/05/0d/51?_=1506335725065"
        )}
      >
        {lists}
      </SiteFooter>
    </StaticRenderer>
  ));
